import { platformBrowser } from '@angular/platform-browser';
import 'zone.js';
import { AppModule } from './app/app-module';
import { defineCustomElements } from '@siemens/ix/loader';
defineCustomElements(window);

platformBrowser()
  .bootstrapModule(AppModule, {})
  .catch((err) => console.error(err));
